import {
  ButtonSecondary,
  ButtonSize,
  IconExpand,
  IconLoader,
  Select,
  SelectSize,
} from '@ui/src';
import { v4 as uuid } from 'uuid';
import { Controller } from 'react-hook-form';
import { AffilatedCompanyFormValues } from '../../../../hoc/new-application/types';
import AffilatedCompany from './affilated-company';
import AdditionalInfoBlock from '../additional-info-block';
import RegulatedCompanyRow from '../../../corporate/aml/parts/row';
import { AffilatedCompaniesTypes } from './types';
import { CustomerStatus } from '../../../../hoc/customers/types';

import cn from '../../../corporate/aml/parts/styles.module.css';

const isOdd = (order: number) => {
  const result = order % 2;

  return Boolean(result);
};

const AffilatedCompanies = ({
  control,
  clearErrors,
  errors,
  status,
  fields,
  affilatedCompaniesValues,
  setAffilatedCompaniesValues,
  affilatedCompaniesIsLoading,
  affilatedCompaniesIsFetching,
  deleteAffilatedCompanyInProgress,
  onDeleteAffilatedCompany,
  selectedAffilatedCompanyId,
  uboPercentage,
  countries,
}: AffilatedCompaniesTypes) => (
  <AdditionalInfoBlock title="Information about affiliated companies">
    <RegulatedCompanyRow
      title={`Are you the director / controlling person / shareholder – beneficial owner of more than ${uboPercentage}% of ownership of a company?`}
    >
      <Controller
        control={control}
        name="hasAffiliatedCompanies"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <Select
            name={name}
            placeholder="Select an option..."
            list={[
              {
                name: 'Yes',
                value: 'yes',
              },
              {
                name: 'No',
                value: 'no',
              },
            ]}
            value={value as string}
            size={SelectSize.SMALL}
            onChange={(e) => {
              onChange(e);
              clearErrors(['hasAffiliatedCompanies']);
            }}
            selectWrapperClassName={
              status === CustomerStatus.CLOSED ? cn.selectDisabled : ''
            }
            disabled={status === CustomerStatus.CLOSED}
            tabIndex={status === CustomerStatus.CLOSED ? -1 : 0}
            error={errors?.belongsToGroup?.message}
            fullWidth
            borderless
          />
        )}
      />
    </RegulatedCompanyRow>
    {fields?.hasAffiliatedCompanies === 'yes' && (
      <div className={cn.accountsCurrenciesList}>
        {errors?.questionnairesAffiliatedCompanies?.message && (
          <div className={cn.questionnarieError}>
            {errors?.questionnairesAffiliatedCompanies?.message}
          </div>
        )}
        {!affilatedCompaniesIsLoading && !affilatedCompaniesIsFetching && (
          <>
            <div className={cn.accountsCurrencyListWrapper}>
              <div className={cn.accountsCurrenciesColumn}>
                {affilatedCompaniesValues
                  ?.filter((item, index) => !isOdd(index))
                  ?.map((item) => (
                    <AffilatedCompany
                      key={item.id}
                      status={status}
                      affilatedCompaniesValues={affilatedCompaniesValues}
                      setAffilatedCompaniesValues={setAffilatedCompaniesValues}
                      deleteAffilatedCompanyInProgress={
                        deleteAffilatedCompanyInProgress
                      }
                      onDeleteAffilatedCompany={onDeleteAffilatedCompany}
                      selectedAffilatedCompanyId={selectedAffilatedCompanyId}
                      countries={countries}
                      index={affilatedCompaniesValues?.findIndex(
                        (company) => company.id === item.id,
                      )}
                      affilatedCompany={item}
                    />
                  ))}
              </div>
              <div className={cn.accountsCurrenciesColumn}>
                {affilatedCompaniesValues
                  ?.filter((item, index) => isOdd(index))
                  ?.map((item) => (
                    <AffilatedCompany
                      key={item.id}
                      status={status}
                      affilatedCompaniesValues={affilatedCompaniesValues}
                      setAffilatedCompaniesValues={setAffilatedCompaniesValues}
                      deleteAffilatedCompanyInProgress={
                        deleteAffilatedCompanyInProgress
                      }
                      onDeleteAffilatedCompany={onDeleteAffilatedCompany}
                      selectedAffilatedCompanyId={selectedAffilatedCompanyId}
                      countries={countries}
                      index={affilatedCompaniesValues?.findIndex(
                        (company) => company.id === item.id,
                      )}
                      affilatedCompany={item}
                    />
                  ))}
              </div>
            </div>
            {status !== CustomerStatus.CLOSED && (
              <ButtonSecondary
                text="Add company"
                icon={<IconExpand />}
                className={`button-white ${cn.addAccountCurrencyButton}`}
                size={ButtonSize.SMALL}
                onClick={() => {
                  let nextAffilatedCompanies: AffilatedCompanyFormValues[] = [];

                  if (affilatedCompaniesValues) {
                    nextAffilatedCompanies = (
                      [] as AffilatedCompanyFormValues[]
                    ).concat(affilatedCompaniesValues);
                  }

                  nextAffilatedCompanies.push({
                    id: `affilated-company-${uuid()}`,
                    name: '',
                    registrationNumber: '',
                    mainActivities: '',
                    position: '',
                    countryId: '',
                    percentageOfOwnership: '',
                  });

                  setAffilatedCompaniesValues(nextAffilatedCompanies);
                }}
              />
            )}
          </>
        )}
        {(affilatedCompaniesIsLoading || affilatedCompaniesIsFetching) && (
          <div className={cn.accountsCurrenciesLoader}>
            <IconLoader />
          </div>
        )}
      </div>
    )}
  </AdditionalInfoBlock>
);

export default AffilatedCompanies;
